/**
 * Created by rathompson on 9/27/22
 * File: V5TableWrapper
 * Project: MSP ©Palo Alto Networks
 * © Palo Alto Networks
 */

import styled from 'styled-components'

const StyledTableWrapper = styled.div`
  div[role="row"] {
    height: auto !important;
  }
  div[role="rowgroup"] {
    &.tw-sticky.tw-top-0 {
      z-index: 1;
    }
  }

  label {
    margin: 0 !important;
  }

  .tw-font-lato.tw-flex.tw-items-center.tw-space-x-2.tw-text-default.dark\\:tw-text-blue-steel-300 {
    gap: 0.125rem;
  }

  a {
    color: rgba(0, 111, 204, var(--tw-text-opacity)) !important;
  }
`

const V5TableWrapper = ({ className: _className = '', children, ...rest }) => {

  const className = [
    'cloud-management-table-wrapper',
    _className
  ].filter(cn => !!cn).join(' ')

  return (
    <StyledTableWrapper {...{ className, ...rest }}>
      {children}
    </StyledTableWrapper>
  )
}

export default V5TableWrapper
